import { ISecondaryVehicleSelectionOptions } from "interfaces/session/IVehicle";

export const YEAR_MAKE_MODEL = ["year", "make", "model"];
export const YEAR_MAKE_MODEL_ENGINE = ["year", "make", "model", "engine"];
export const MAKE_YEAR_MODEL = ["make", "year", "model"];
export const MAKE_MODEL_YEAR = ["make", "model", "year"];
export const ENGINE_TITLE = "ep.Engine";
export const SECONDARY_VEHICLE_SELECTION_OPTIONS = [ISecondaryVehicleSelectionOptions.TireSizeAndPosition, ISecondaryVehicleSelectionOptions.WheelSizeAndPosition];
